import { render, staticRenderFns } from "./DiscountDelete.vue?vue&type=template&id=d2c8925e"
import script from "./DiscountDelete.vue?vue&type=script&lang=js"
export * from "./DiscountDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports